import React from 'react';
import PropTypes from 'prop-types';
import { SankeyBarChart } from '../charts/SankeyBarChart';
import { drawTimeline } from '../charts/Timeline';
import { withStyles } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import IconButton from '@material-ui/core/IconButton';
import PlayIcon from '@material-ui/icons/PlayArrow';
import PauseIcon from '@material-ui/icons/Pause';
import Button from '@material-ui/core/Button';
import './Journey.css';

const styles = theme => ({
    button: {
        margin: theme.spacing.unit,
    },
    input: {
        display: 'none',
    },
});

class Journey extends React.Component {
    componentDidMount() {
        new SankeyBarChart(`#${this.props.id}-journey-viz`, `${this.props.id}-journey-viz-svg`, this.props.data, { height: 150 }, this.props.data[0].enter.value);
    }

    render() {
        const { classes } = this.props;

        return (
            <div>
                <div id={`${this.props.id}-journey-viz`} className="sankey-barchart">
                    <div className="header" width="100%" style={{ position: 'relative', display: 'block', clear: 'both' }} />
                    <svg id={`${this.props.id}-journey-viz-svg`} height="100%" width="100%">
                        <g className="x-lines" transform="translate(0,0)" />
                        <g className="y-lines" transform="translate(0,0)" />
                        <g className="y-text" transform="translate(0,0)" />
                        <g className="edges" transform="translate(0,0)" />
                    </svg>
                </div>
            </div>

        );
    }
}

Journey.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Journey);



// WEBPACK FOOTER //
// ./src/components/Journey.js